import { Maybe } from 'maybeasy';
import { PlusIcon, Typography } from '@execonline-inc/execonline-ui';
import type { JSX } from 'react';
import { T, TPlainTextKey } from '../../../../../../Translations';

interface EmptyStateProps {
  text: TPlainTextKey;
  onClick: () => void;
  intercomTarget: Maybe<string>;
}

export function EmptyState({ text, onClick, intercomTarget }: EmptyStateProps): JSX.Element {
  return (
    <button
      type="button"
      className="flex items-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1 rounded"
      onClick={onClick}
      data-intercom-target={intercomTarget.cata({ Just: (t) => t, Nothing: () => undefined })}
    >
      <PlusIcon color="teal" size="sm" />
      <Typography color="teal" variant="caption" fontWeight="semibold" className="ml-1">
        <T kind={text} />
      </Typography>
    </button>
  );
}
